import { fetchResults, buildPostJson } from './functions'
let typingTimer

function initSearchInput (filterSetKeyPrefix, isActiveFiltering = true) {
  // Search Functionality
  $('.search-input').on('keyup', function () {
    clearTimeout(typingTimer)
    typingTimer = setTimeout(searchInputDoneTyping, doneTypingInterval, filterSetKeyPrefix, isActiveFiltering)
  })

  $('.search-input').on('keydown', function () {
    clearTimeout(typingTimer)
  })
}

function searchInputDoneTyping (filterSetKeyPrefix, isActiveFiltering = true) {
  filters[filterSetKeyPrefix + '_search'] = $('.search-input').val()
  filters[filterSetKeyPrefix + '_filters'].page = 1

  const event = new Event('FiltersUpdated')
  document.dispatchEvent(event)

  if (isActiveFiltering) {
    fetchResults(
      buildPostJson(filters), filterSetKeyPrefix
    )
  }
}

function initSearch (searchInputSelector, searchLoadingCallback, searchCompleteCallback) {
  $(searchInputSelector).on('keyup', function () {
    clearTimeout(typingTimer)
    typingTimer = setTimeout(searchCompleteCallback, doneTypingInterval ?? 1000)
  })

  $(searchInputSelector).on('keydown', function () {
    clearTimeout(typingTimer)
    searchLoadingCallback()
  })
}

export { initSearchInput, initSearch }
